import api from '../api';

export const getFormGroups = async (projectId) => {
  const res = await api.get(`/projects/${projectId}/formgroups`);
  return res.data;
};

export const getFieldGroups = async (projectId, formGroupId) => {
  const res = await api.get(`/projects/${projectId}/formgroups/${formGroupId}/field-groups`);
  return res.data;
};

export const createFieldGroup = async (projectId, formGroupId, data) => {
  const res = await api.post(`/projects/${projectId}/formgroups/${formGroupId}/field-groups`, data);
  return res.data;
};

export const updateFieldGroup = async (projectId, formGroupId, groupLabel, data) => {
  const encodedLabel = encodeURIComponent(groupLabel);
  const res = await api.put(`/projects/${projectId}/formgroups/${formGroupId}/field-groups/${encodedLabel}`, data);
  return res.data;
};

export const deleteFieldGroup = async (projectId, formGroupId, groupLabel) => {
  const encodedLabel = encodeURIComponent(groupLabel);
  const res = await api.delete(`/projects/${projectId}/formgroups/${formGroupId}/field-groups/${encodedLabel}`);
  return res.data;
};

export const reorderFieldGroups = async (projectId, formGroupId, orderedGroupLabels) => {
  const res = await api.put(`/projects/${projectId}/formgroups/${formGroupId}/field-groups/reorder`, {
    orderedGroupLabels
  });
  return res.data;
};
